import { render } from "./TariffSetupComponent.vue?vue&type=template&id=b9d974d0&scoped=true"
import script from "./TariffSetupComponent.vue?vue&type=script&lang=js"
export * from "./TariffSetupComponent.vue?vue&type=script&lang=js"

import "./TariffSetupComponent.vue?vue&type=style&index=0&id=b9d974d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9d974d0"]])

export default __exports__